// extracted by mini-css-extract-plugin
export default {"root":"EditorAutoSaveLabel_root__J26xh","error":"EditorAutoSaveLabel_error__j2cGv","success":"EditorAutoSaveLabel_success__tOzKP"};